import { Card, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/redesign/system/ui-components";
import { type ReactNode } from "react";

interface WorkplaceReferralCardsProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export function WorkplaceReferralCard(props: WorkplaceReferralCardsProps) {
  const { children, sx } = props;
  return (
    <Card
      variant="outlined"
      sx={mergeSxProps((theme) => ({ background: theme.palette.grey[100] }), sx)}
    >
      {children}
    </Card>
  );
}
